// Components
import CheckboxInput from "components/inputs/checkbox"
// Data
import { parseDate } from "data/lib/dates"
import notificationService from 'data/notification'
import propertyReportService from "data/reports-property"
import underwritingService from "data/underwriting"
import _ from 'lodash'
import calcService from "data/calc"
import Moment from 'moment'
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { DateText_s, ReportForm_s } from "styles/report-styles"

interface RentRollProps {
  property: object
}

const RentRoll: FC<RentRollProps> = (props) => {
  const [display_date, setDisplayDate] = useState<string>(underwritingService.getReportBeginDefault(true, null, true))
  const [display_all, setDisplayAll] = useState<boolean>(false);
  const [display_notes, setDisplayNotes] = useState<boolean>(true);

  function submit():void {
    propertyReportService.propertyReport({
      report: 'rent_roll',
      params: {
        display_all,
        display_notes,
        display_date: parseDate(display_date).format('MM/DD/YYYY')
      }
    });
  }

  useEffect(() => {
    const analysisBegin = Moment(props.property['analysisbegindate']);
    let date:any = display_date;
    if (parseDate(date).isBefore(parseDate(analysisBegin))){
      date = analysisBegin;
      notificationService.notify({
        type: "warn",
        message: 'Report Begin Date adjusted to earliest possible date, the Analysis Begin',
        dismiss: 5000
      })
      setDisplayDate(date)
    }
  }, [display_date])

  const disabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Calculation Required' : 'Run Report'

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <Label_s>Display All Base Rent</Label_s>
          <CheckboxInput
            field="display_all"
            value={display_all}
            persist={(field:string, val:boolean) => setDisplayAll(val)}
          />
        </div>
        <div>
          <Label_s>Display Notes</Label_s>
          <CheckboxInput
            field="display_notes"
            value={display_notes}
            persist={(field:string, val:boolean) => setDisplayNotes(val)}
          />
        </div>
        <div>
          <Label_s>Base Rent Display Date</Label_s>
          <DateText_s withoutDays value={parseDate(display_date).format('MM/DD/YYYY')} onChange={setDisplayDate} onBlur={setDisplayDate} persist={setDisplayDate} />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default RentRoll
